<template>
    <b-modal  v-model="visible" id="NewsModal" size="lg" centered class="p-2 p-md-4 mx-2 mx-md-auto" @hide="onHideModal"
             dialog-class="w-75 h-75" content-class="overflow-hidden h-75" no-close-on-backdrop no-close-on-esc body-class="p-2 overflow-hidden">

        <!-- Header avec titre de la notification -->
        <template #modal-header="{close}">
            <h6><b-icon icon="bell-fill" class="mr-2" />
                {{ displaySingleNews() ? currentNotification?.Title : 'Notifications' }}
            </h6>
                <!-- Bouton pour fermer la modal -->
            <b-col v-if="displaySingleNews()" cols="3" class=" pr-0 p-1 pl-4 text-right">
                <b-icon role="button" icon="x-lg" font-scale="1.5" @click="close();" v-b-tooltip.hover :title="$t('Close')"  />
            </b-col>
        </template>
 
        <b-card no-body class="h-100 minh-100 d-flex flex-column">
            <b-container fluid class="overflow-auto flex-grow-1">
                <!-- Affichage unifié utilisant displayedNews -->
                <b-row v-for="news in displayedNews()" :key="news.Id">
                    <b-col cols="12">
                        <b-card-body>
                            <NewsContent :News="news" />
                        </b-card-body>
                    </b-col>
                </b-row>
            </b-container>
        </b-card>

        <!-- Footer avec navigation -->
        <template #modal-footer>
            <b-col cols="8" class="m-0 p-0 d-flex align-items-end justify-content-end">
                <!-- Bouton Suivant visible si ce n'est pas la dernière -->
                <b-button v-if="!displaySingleNews() && currentIndex < (NewsNotifications?.length - 1)" 
                        @click="nextNews()" 
                        :variant="Variant" 
                        pill>
                    {{ $t('Next') }}
                </b-button>

                <!-- Bouton Fermer si on est à la dernière news ou si on affiche qu'une seule news -->
                <b-button v-if="currentIndex === (NewsNotifications?.length - 1) || shouldDisplaySingleNews" 
                        @click="onHideModal"
                        :variant="Variant" 
                        pill>
                    {{ $t('Close') }}
                </b-button>
            </b-col>
        </template>

    </b-modal>
</template>

<script lang="ts">
    import {Vue, Prop, PropSync, Component} from 'vue-property-decorator';
     import { mixins } from 'vue-class-component';
    import { Getter } from 'vuex-class';
    import axios from "axios";
    import { API_URL } from "@/App.settings";
    import Dictionary from "@/types/Dictionary";
    import NewsNotification from '@/types/NewsNotification';
    import NewsContent from './News/NewsContent.vue';
    import { LinkUtils, ThemeUtils } from "@/components/commons/Utils";

    /** Modal servant à afficher les news */
    @Component({
        components: {
            NewsContent
        }
    })
    export default class News extends mixins( Vue, LinkUtils, ThemeUtils) {

        @PropSync('Visible', { default: () => false })
        public visible!: boolean;

       /**  Notification à afficher */
        @Prop({ default: null })
        public NewsNotifications!: NewsNotification[] | null;

        /** Variant de couleur à utiliser sur le tableau de bord */
        private Variant : string = 'info';

        /**  Index courant de la news affichée */
        private currentIndex: number = 0;

        /** News Notification selectionnée */
        @Getter('NotificationsStore/GetSelectedNewsNotification')
        private currentNotification!: NewsNotification | null;

        /** au click si on doit afficher la news unique */
        @Getter('NotificationsStore/ShouldDisplaySingleNews')
        private shouldDisplaySingleNews!: boolean;

        /** Mode 1: Affichage d'une seule news sélectionnée */
        private displaySingleNews(): boolean {
            return this.shouldDisplaySingleNews && this.currentNotification !== null;
        }

        /** Mode 2: Affichage au début de la session (Navigation séquentielle des news ) */
        private displayedNews(): NewsNotification[] {
            if (this.displaySingleNews() && this.currentNotification) {
                return [this.currentNotification];
            }
            if (this.NewsNotifications && this.NewsNotifications.length > 0) {
                return [this.NewsNotifications[this.currentIndex]];
            }
            return [];
        }

        /** Passage à la news suivante suivante */
        private nextNews() {
            // Passage de la news courante en lue
            this.setReadNews(this.currentIndex);

            if (this.currentIndex < this.NewsNotifications.length - 1) {
                // On incrémente l'index pour passer à la news suivante
                this.currentIndex++;
            }
        }

        /** Permet de passer de la news courante en lue */
        private setReadNews(index: number): void {
            // Selection de la notification courante
            this.$store.dispatch('NotificationsStore/SetCurrentNewsNotification', this.NewsNotifications[index]);

            // On passe la notification courante en lue
            this.$store.dispatch('NotificationsStore/MarkNewsAsRead');

            // Reset de la notification courante (sinon on reste sur la même notification)
            this.$store.dispatch('NotificationsStore/SetCurrentNewsNotification', null);

            // Rechargement de la liste des notifications
            this.$store.dispatch('NotificationsStore/LoadNewsNotifications', { lazy : true });
        }

        /** Gestionnaire pour la fermeture de la modale */
        private onHideModal(): void {
            
            // Passage de la news courante en lue
            this.setReadNews(this.currentIndex);
                        
            // 2. Fermeture via le store
            this.$store.dispatch('NotificationsStore/HideNews')

            // 4. Reset de l'index pour la prochaine ouverture
            this.currentIndex = 0;
        }
    }


</script>

<style scoped></style>
